import './index.css';
import { useState } from 'react';
import { AuthProvider, useAuth } from './hooks/useAuth';
import LoginPage from './pages/LoginPage';
import SvPage from './pages/SvPage';
import TmPage from './pages/TmPage';
import RmPage from './pages/RmPage';
import AdminPage from './pages/AdminPage';
import TrainerPage from './pages/TrainerPage';
import SetupPage from './pages/SetupPage';
import { Loader } from './components/UI';
import SaveStatus from './components/SaveStatus';
import ScrollTop from './components/ScrollTop';
import { initOutbox } from './lib/outbox';

initOutbox();

function AppRouter() {
  const { user, loading } = useAuth();
  const [setupDone, setSetupDone] = useState(false);

  if (loading) return <Loader text="Инициализация..." />;

  if (!setupDone && !user) {
    return <SetupPage onDone={() => setSetupDone(true)} />;
  }

  if (!user) return <LoginPage />;

  switch (user.role) {
    case 'sv':    return <SvPage />;
    case 'tm':    return <TmPage />;
    case 'rm':    return <RmPage />;
    case 'trainer': return <TrainerPage />;
    case 'admin': return <AdminPage />;
    default:      return <LoginPage />;
  }
}

export default function App() {
  return (
    <AuthProvider>
      <AppRouter />
      <ScrollTop />
      <SaveStatus />
    </AuthProvider>
  );
}
